export default {
  termId: '',
  term: '',
  confirmationId: '',
  hasCapstone: null,
  scheduleAdmin: {
    searchText: '',
    term: '',
    filter: '',
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    }
  },
  programAdmin: {
    searchText: '',
    term: '',
    filter: null,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    }
  },
  studyAbroad: {
    showFilter: false,
    filter: {
      name: '',
      status: '',
      term: [],
      major: [],
      partner: [],
      location: [],
      gradYear: []
    }
  },
  music: {
    admin: {
      section: 'scan',
      term: '',
      terms: [],
      stuGroup: '',
      classLevel: [],
      event: '',
      lesson: '',
      eventAttended: true,
      instrument: [],
      instructor: [],
      accompanist: [],
      course: ''
    }
  },
  capstone: {
    term: '',
    courses: [],
    evalCourse: ''
  }
}
